import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function DuePrint(body, name) {
    let bList = []
    let duesTotal = ['Summery', 0, 0, 0];
    let i = 0
    body.forEach(element => {
        const b = [
            `[${element.data.name.trim()}]`,
            printFormatNumber(element.data.balance),
            printFormatNumber(element.data.dues40),
            printFormatNumber(element.data.dues60)]
        duesTotal[1] += sF(element.data.balance);
        duesTotal[2] += sF(element.data.dues40);
        duesTotal[3] += sF(element.data.dues60);
        bList = [...bList, b]
        if (element.children) {
            element.children.forEach(child => {
                const c = [
                    child.data.name,
                    printFormatNumber(child.data.balance),
                    printFormatNumber(child.data.dues40),
                    printFormatNumber(child.data.dues60),
                ]
                bList = [...bList, c]

            })
        }
    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Name', 'Balance', 'Dues 40 Days', 'Dues 60 Days'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Dues Report", 300, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            foot: [duesTotal.map(item => {
                return item.toLocaleString()
            })],
            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "right"},
                2: {halign: "right"},
                3: {halign: "right"}
            },
        }
    )
    doc.save(`DuesAt-${ToBritishDate(new Date())}.pdf`);
}



